import type { CreateTopUpCommand, DepositTopUp } from '@sirius/contracts';

import { request, upload } from '../client';

/** Мої поповнення депозиту, найновіші першими. Відкриті несуть реквізити переказу. */
export const listMyTopUps = (): Promise<DepositTopUp[]> => request<DepositTopUp[]>('/me/top-ups');

/** Новий запит: номер для призначення платежу й реквізити. Гроші зараховує оператор після переказу. */
export const createTopUp = (command: CreateTopUpCommand): Promise<DepositTopUp> =>
	request<DepositTopUp>('/me/top-ups', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(command),
	});

/** «Я переказав». Квитанція (PDF або зображення до 10 МБ) і примітка — необовʼязкові. */
export const submitTopUp = (id: string, receipt: File | null, note: string): Promise<DepositTopUp> => {
	const form = new FormData();
	if (receipt) form.append('file', receipt);
	if (note.trim()) form.append('note', note.trim());
	return upload<DepositTopUp>(`/me/top-ups/${encodeURIComponent(id)}/submit`, form);
};

/** Скасувати можна лише до «переказав». */
export const cancelTopUp = (id: string): Promise<DepositTopUp> =>
	request<DepositTopUp>(`/me/top-ups/${encodeURIComponent(id)}/cancel`, { method: 'POST' });
